import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';

export interface SentryEnvironmentConfig {
  production: boolean;
  sentryEnabled: boolean;
  sentryDsn?: string;
  sentryEnvironment?: string;
  sentryRelease?: string;
}

let sentryInitialized = false;

export function shouldInitSentry(env: SentryEnvironmentConfig): boolean {
  return Boolean(env.production && env.sentryEnabled && env.sentryDsn);
}

export function initSentry(): void {
  if (sentryInitialized || typeof window === 'undefined') {
    return;
  }

  if (!shouldInitSentry(environment)) {
    return;
  }

  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.sentryEnvironment,
    release: environment.sentryRelease,
    autoSessionTracking: false,
    beforeSend(event) {
      const value = event.exception?.values?.[0]?.value;
      if (typeof value === 'string' && (value.includes('ChunkLoadError') || value.includes('Loading chunk'))) {
        return null;
      }
      return event;
    },
  });


  sentryInitialized = true;
}
